/* Stable editorial anchors while Shopify keeps ownership of section IDs. */
function roweEditorialAnchors() {
  const sections = { 'rowe-pdp-sample': 'rowe_pdp_sample', 'inside-the-book': 'rowe_pdp_contents' };
  for (const [anchor, suffix] of Object.entries(sections)) {
    const section = document.querySelector(`[id$="__${suffix}"]`);
    if (!section || document.getElementById(anchor)) continue;
    const marker = document.createElement('span');
    marker.id = anchor;
    marker.style.cssText = 'display:block;scroll-margin-top:100px';
    section.prepend(marker);
  }
  document.querySelectorAll('[id$="__rowe_pdp_faq"] details').forEach(details => {
    if (details.dataset.roweA11yBound) return;
    const summary = details.querySelector('summary');
    if (!summary) return;
    const syncExpanded = () => summary.setAttribute('aria-expanded', String(details.open));
    details.addEventListener('toggle', syncExpanded);
    syncExpanded();
    details.parentElement.querySelectorAll('[role="region"]').forEach(region => {
      region.setAttribute('aria-labelledby', summary.id);
    });
    details.dataset.roweA11yBound = 'true';
  });
  if (Object.hasOwn(sections, location.hash.slice(1))) {
    document.getElementById(location.hash.slice(1))?.scrollIntoView();
  }
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', roweEditorialAnchors);
else roweEditorialAnchors();
document.addEventListener('shopify:section:load', roweEditorialAnchors);
